export const heading = 'Company feature';

export const COMPANY_ASSOCIATIONS = {
  DRUG_ID: 'DRUG ID',
  DRUG_KEY: 'DRUG KEY',
  DRUG_NAME: 'DRUG NAME',
  NO_DATA_AVAILABLE: 'No Data Available',
};
